<app-spinner *ngIf="displayLoadingIndicator && !newsModel"></app-spinner>

<ng-container *ngIf="newsModel">
    <div class="alert alert-secondary" *ngIf="displayEmptyInformation && !newsModel.length">
        {{'inbox.news.emptyList' | transloco}}
    </div>

    <div class="d-flex flex-column gap-2">
        <div *ngFor="let model of newsModel">
            <a [routerLink]="['/news', model.id]" class="text-decoration-none text-dark">
                <div class="alert alert-primary border-0 d-felx flex-column gap-1">
                    <!-- Row for Title and Date -->
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="h8">{{ model.title }}</span>
                        <div class="fs-4 mb-0 fw-regular text-nowrap">
                            {{ model.publicationFrom | date: "dd.MM.yy" }}
                        </div>
                    </div>

                    <!-- Row for News Text and Chevron Icon -->
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-truncate flex-grow-1 h8 fw-regular">
                            {{ model.preview }}
                        </p>
                        <i class="fa fa-chevron-right ms-3"></i>
                    </div>
                </div>
            </a>
        </div>
    </div>
</ng-container>